<template>
  <div class="item">
    <div class="item-top">
      <div class="item-left">
        <div class="info">
          <h2 class="info-name">{{info.name}}</h2>
          <div class="info-age">
            <span>{{info.sex == '1' ? '男' : '女'}} {{info.age}}岁</span>
          </div>
          <div v-if="!info.reporterCount" class="info-state">
            <span>未填报</span>
          </div>
          <div v-else>
            <div v-if="type === 'abnormal'" class="info-state info-state-num-ab">
              <span>异常次数：{{info.reporterCount}}次</span>
            </div>
            <div v-else class="info-state info-state-num">
              <span>今日填报：{{info.reporterCount}}次</span>
            </div>
          </div>
        </div>
        <p class="phone">{{info.mobile}}</p>
      </div>
      <img class="item-icon" :src="showBottom ? iconup : icondown" @click="handleShow" />
    </div>
    <div class="item-bottom" v-if="showBottom">
      <div class="card">
        <div class="card-item" v-if="info.idNum">
          <span class="card-label">身份证号</span>
          <span class="card-desc">{{info.idNum}}</span>
        </div>
        <div class="card-item" v-if="info.relationName">
          <span class="card-label">与填报人关系</span>
          <span class="card-desc">{{info.relationName}}</span>
        </div>
        <div class="card-item" v-if="info.acidTime">
          <span class="card-label">最近一次核酸</span>
          <span class="card-desc">{{info.acidTime}}</span>
        </div>
        <div class="card-item" v-if="info.acidNum">
          <span class="card-label">核酸检测次数</span>
          <span class="card-desc">{{info.acidNum}}次</span>
        </div>
        <div class="card-item">
          <span class="card-label">所在单位</span>
          <span class="card-desc">{{info.companyName}}{{info.gradeName}}{{info.className}}</span>
        </div>
        <div class="card-item">
          <span class="card-label">现居地址</span>
          <span class="card-desc">{{info.address}}</span>
        </div>
        <div class="card-item">
          <span class="card-label">疫苗接种情况</span>
          <span v-if="info.vaccines == 1" class="card-desc">未接种</span>
          <span v-if="info.vaccines == 2" class="card-desc">已接种未完成</span>
          <span v-if="info.vaccines == 3" class="card-desc">已接种完毕</span>
        </div>
        <div class="card-item" v-if="info.antigen">
          <span class="card-label">抗原检测结果</span>
          <span v-if="info.antigen == 1" class="card-desc">阴性</span>
          <span v-if="info.antigen == 2" class="card-desc">阳性</span>
          <span v-if="info.antigen == 3" class="card-desc">无效</span>
        </div>
      </div>
      <div class="button" @click="handleEmit">
        <span>点击查看填报记录</span>
      </div>
    </div>
  </div>
</template>

<script>
const icondown = require('../assets/images/icon-down-c.png')
const iconup = require('../assets/images/icon-up.png')
export default {
  props: {
    info: Object,
    type: {
      type: String
    }
  },
  data() {
    return {
      icondown: icondown,
      iconup: iconup,
      showBottom: false
    }
  },
  methods: {
    handleShow(val) {
      this.showBottom = !this.showBottom
    },

    // 点击向父组件触发
    handleEmit() {
      this.$emit('onShow', this.info.id)
    }
  }
}
</script>

<style scoped>
  .item {
    box-sizing: border-box;
    padding: .3rem;
    background-color: #fff;
    margin-bottom: .2rem;
    border-radius: .1rem;
  }
  .item-top {
    display: flex;
    align-items: center;
  }
  .item-left {
    flex: 1;
  }
  .info {
    display: flex;
    align-items: center;
  }
  .info-name {
    font-size: .34rem;
    color: #333;
    font-weight: bold;
    margin-right: .2rem;
  }
  .info-age {
    display: flex;
    align-items: center;
    height: .36rem;
    padding: 0 .1rem;
    font-size: .24rem;
    color: #1A8FFF;
    border: 1px solid #3396FB;
    border-radius: 3px;
    line-height: .36rem;
    margin-right: .2rem;
  }
  .info-state {
    display: flex;
    align-items: center;
    height: .36rem;
    padding: 0 .1rem;
    font-size: .24rem;
    color: #fff;
    background-color: #FF8D05;
    border: 1px solid #FF8D05;
    border-radius: 3px;
  }
  .info-state-num {
    background-color: #338EF9;
    border: 1px solid #338EF9;
  }
  .info-state-num-ab {
    background-color: #FF5E5B;
    border: 1px solid #FF5E5B;
  }
  .phone {
    font-size: .24rem;
    color: #999;
    margin-top: .23rem;
  }
  .item-icon {
    width: .38rem;
    height: .38rem;
  }
  .item-bottom {
    margin-top: .3rem;
    border-top: 1px solid #EAEAEA;
  }
  .card {
    box-sizing: border-box;
    margin-top: .24rem;
    padding: .3rem .24rem;
    background-color: #F9FAFE;
    border-radius: .1rem;
  }
  .card-item {
    display: flex;
    margin-top: .3rem;
  }
  .card-item:first-child {
    margin-top: 0;
  }
  .card-label {
    width: 2rem;
    font-size: .28rem;
    color: #333;
  }
  .card-desc {
    flex: 1;
    font-size: .28rem;
    color: #999;
  }
  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: .8rem;
    margin-top: .24rem;
    border-radius: .1rem;
    background-color: #EAF3FF;
  }
  .button > span {
    font-size: .3rem;
    color: #1A8FFF;
  }
</style>